export const NOT_SET = 'Not Set';
//# sourceMappingURL=not-set.js.map